// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"15":"5b335844","80":"3f037f55","188":"e9c4e061","475":"dc3a92bd","533":"3e486d13","656":"39c5ca4d","745":"c09ee87a","834":"13698894","972":"2663324b","992":"bd662b52"}[chunkId] + ".js";
};